export const POOLS_LIST_GET = 'POOLS_LIST_GET'
export const POOLS_LIST_UPDATE = 'POOLS_LIST_UPDATE'
export const POOLS_LIST_ITEM_READ = 'POOLS_LIST_ITEM_READ'
export const POOLS_LIST_ITEM_WRITE = 'POOLS_LIST_ITEM_WRITE'
export const POOLS_SINGLE_TRANSACTIONS_GET = 'POOLS_SINGLE_TRANSACTIONS_GET'
export const POOLS_SINGLE_DETAILS_GET = 'POOLS_SINGLE_DETAILS_GET'
export const POOLS_GROUP_DETAILS_GET = 'POOLS_GROUP_DETAILS_GET'
